import Header from "./header";
import Paper from "./paper";
import Editor from "./editor";
import { useState } from "react";
import { Route } from "react-router-dom";
import PageContext from "../../contexts/page";
import BlocksContext from "../../contexts/blocks";
import EditorContext from "../../contexts/editor";
import EditContext from "../../contexts/edit";
import WorkflowsContext from "../../contexts/workflows";
import UtilitiesContext from "../../contexts/utilities";
import SourcesContext from "../../contexts/sources";
import Sidebar from "./sidebar";
import CCPContext from "../../contexts/ccp";
import DragLayer from "./dragPreview";
import Workflows from "./workflows";
import Utilities from "./utilities";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
export default function Canvas() {
  const [sidebar, setSidebar] = useState("blocks");
  const [editor, setEditor] = useState(true);
  const [width, setWidth] = useState(1200);
  const [zoom, setZoom] = useState(100);

  return (
    <Route path="/:appId/canvas/:type/:pageId">
      <BlocksContext>
        <EditorContext>
          <PageContext>
            <WorkflowsContext>
              <UtilitiesContext>
                <SourcesContext>
                  <CCPContext>
                    <EditContext>
                      <div style={{ display: "flex" }} className="page">
                        {/* <Header
                    width={{ value: width, set: setWidth }}
                    zoom={{ value: zoom, set: setZoom }}
                    sidebar={{ value: sidebar, set: setSidebar }}
                    editor={{ value: editor, set: setEditor }}
                  /> */}
                        <DndProvider backend={HTML5Backend}>
                          <Sidebar />
                          <Paper editor={{ value: editor, set: setEditor }} />

                          <Editor open={editor} />
                          <DragLayer />
                        </DndProvider>
                        <Workflows />
                        <Utilities />
                      </div>
                    </EditContext>
                  </CCPContext>
                </SourcesContext>
              </UtilitiesContext>
            </WorkflowsContext>
          </PageContext>
        </EditorContext>
      </BlocksContext>
    </Route>
  );
}
